import { useCallback, useMemo, useState } from "react";
import TreeNodeComponent from "./TreeModeComponent";
import { filterTree } from "./PostmanVIewHelper";

function TreeSidebar({ title, tree, selectedId, onSelect, open }) {
  const [query, setQuery] = useState("");
  const [collapsed, setCollapsed] = useState(() => new Set());
  const q = query.trim().toLowerCase();
  const visible = useMemo(() => filterTree(tree, q), [tree, q]);

  const toggle = useCallback((id) => {
    setCollapsed((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  }, []);

  return (
    <aside className={`ad-side ${open ? "is-open" : ""}`}>
      <button type="button" className="ad-brand" onClick={() => onSelect("")}>
        {title}
      </button>
      <input
        className="ad-search"
        type="search"
        placeholder="Search name, path, or method"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        aria-label="Search endpoints"
      />
      <nav aria-label="Endpoints">
        {visible.length === 0 ? (
          <p className="ad-empty">No endpoint matches “{query}”. Try a shorter term or a path such as “qris”.</p>
        ) : (
          <ul className="ad-tree">
            {visible.map((n) => (
              <TreeNodeComponent
                key={n.id}
                node={n}
                selectedId={selectedId}
                onSelect={onSelect}
                collapsed={collapsed}
                toggle={toggle}
                forceOpen={!!q}
              />
            ))}
          </ul>
        )}
      </nav>
    </aside>
  );
}

export default TreeSidebar